import REQUEST from './Request';
import { GetUserToken } from './localStorageService';
import { ApiBaseUrl } from './config';
import axios from 'axios';

// Create a custom client for ApiBaseUrl2
const client2 = axios.create({
  baseURL: ApiBaseUrl + "/api/",
});

// Enhanced reservation submission
export const submitEnhancedReservation = async (formData) => {
  return await REQUEST({
    method: 'POST',
    url: `Reservation/enhanced-reservation`,
    data: formData
  });
};

// Public reservation details (no auth required)
export const getReservationById = async (id) => {
  const response = await axios.get(`${ApiBaseUrl}/api/Reservation/${id}`);
  return response.data;
};

// Add one or more clients to a reservation
export const addReservationClients = async (reservationId, clientIds) => {
  return await REQUEST({
    method: 'POST',
    url: `Reservation/${reservationId}/clients`,
    data: { clientIds: Array.isArray(clientIds) ? clientIds : [clientIds] },
  });
};

// Remove a client from a reservation (400 if only client)
export const removeReservationClient = async (reservationId, clientId) => {
  return await REQUEST({
    method: 'DELETE',
    url: `Reservation/${reservationId}/clients/${clientId}`,
  });
};

// Set the primary client (main contact) for a reservation
export const setReservationPrimaryClient = async (reservationId, clientId) => {
  return await REQUEST({
    method: 'PUT',
    url: `Reservation/${reservationId}/clients/primary`,
    data: { clientId },
  });
};

// File upload for reservation
export const uploadReservationFiles = async (reservationId, files) => {
  const formData = new FormData();
  formData.append('ReservationId', reservationId);
  
  if (files.idFront) {
    formData.append('IdFront', files.idFront);
    console.log('Added IdFront file:', files.idFront.name);
  }
  if (files.idBack) {
    formData.append('IdBack', files.idBack);
    console.log('Added IdBack file:', files.idBack.name);
  }
  if (files.other) {
    const otherFiles = Array.isArray(files.other) ? files.other : [files.other];
    otherFiles.forEach((file) => {
      if (!file) return;
      formData.append('Other', file); // append multiple times with same key
      console.log('Added Other file:', file.name);
    });
  }
  
  console.log('Uploading files to Reservation/upload-registration-files');
  console.log('FormData contents:');
  for (let [key, value] of formData.entries()) {
    console.log(key, value);
  }
  
  return await REQUEST({
    method: 'POST',
    url: `Reservation/upload-registration-files`,
    data: formData
  });
}; 